import React from 'react';
export function SolutionSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-224">
      <div className="max-w-4xl mx-auto" data-id="element-225">
        <div className="text-center mb-12" data-id="element-226">
          <div className="inline-block bg-green-100 text-green-800 font-black px-6 py-2 rounded-full mb-6 border-2 border-green-300 text-xl tracking-widest" data-id="element-227">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6" data-id="element-228">
            RESET CORPORAL 30D
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-229">
            Un sistema completo diseñado para personas ocupadas que quieren
            resultados reales sin extremos.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-16" data-id="element-230">
          <div className="bg-gray-50 px-6 py-4 rounded-lg font-bold text-lg text-gray-800 shadow-sm border border-gray-200 w-full md:w-auto text-center" data-id="element-231">
            📂 Accedes al programa
          </div>
          <div className="hidden md:block text-gray-400 font-bold text-2xl" data-id="element-232">
            →
          </div>
          <div className="bg-gray-50 px-6 py-4 rounded-lg font-bold text-lg text-gray-800 shadow-sm border border-gray-200 w-full md:w-auto text-center" data-id="element-233">
            👆 Sigues la estructura diaria
          </div>
          <div className="hidden md:block text-gray-400 font-bold text-2xl" data-id="element-234">
            →
          </div>
          <div className="bg-green-50 px-6 py-4 rounded-lg font-black text-lg text-green-800 shadow-sm border-2 border-green-300 w-full md:w-auto text-center" data-id="element-235">
            🔥 Ejecutas durante 30 días
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-236">
          <p className="text-2xl font-black text-gray-900 mb-2" data-id="element-237">
            Sin improvisar. Sin pasar hambre extrema. Sin entrenamientos
            imposibles.
          </p>
          <p className="text-3xl text-green-600 font-black uppercase tracking-wide" data-id="element-238">
            Solo estructura clara.
          </p>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-239">
          <h3 className="text-3xl md:text-4xl font-black text-center mb-10 text-yellow-400" data-id="element-240">
            📘 ¿Qué incluye exactamente RESET CORPORAL 30D?
          </h3>
          <p className="text-xl text-center mb-10 font-medium" data-id="element-241">
            Un sistema dividido en 5 módulos estratégicos:
          </p>

          <div className="space-y-6" data-id="element-242">
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-colors" data-id="element-243">
              <h4 className="text-2xl font-bold text-blue-400 mb-2 flex items-center" data-id="element-244">
                <span className="mr-3" data-id="element-245">📘</span> TOMO 1 – Fundamentos del Cambio
              </h4>
              <p className="text-gray-300 text-lg" data-id="element-246">
                Entiende cómo funciona realmente la pérdida de grasa y prepara
                tu mente para 30 días de estructura real.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-green-500 transition-colors" data-id="element-247">
              <h4 className="text-2xl font-bold text-green-400 mb-2 flex items-center" data-id="element-248">
                <span className="mr-3" data-id="element-249">📗</span> TOMO 2 – Nutrición Inteligente
              </h4>
              <p className="text-gray-300 text-lg" data-id="element-250">
                Método del plato, organización en 60 minutos y menú base simple
                para crear déficit sin hambre extrema.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-yellow-500 transition-colors" data-id="element-251">
              <h4 className="text-2xl font-bold text-yellow-400 mb-2 flex items-center" data-id="element-252">
                <span className="mr-3" data-id="element-253">📙</span> TOMO 3 – Control de Ansiedad
              </h4>
              <p className="text-gray-300 text-lg" data-id="element-254">
                Técnicas prácticas para frenar impulsos, romper el ciclo
                culpa–exceso y recuperar el control.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-red-500 transition-colors" data-id="element-255">
              <h4 className="text-2xl font-bold text-red-400 mb-2 flex items-center" data-id="element-256">
                <span className="mr-3" data-id="element-257">📕</span> TOMO 4 – Movimiento Estratégico
              </h4>
              <p className="text-gray-300 text-lg" data-id="element-258">
                Rutinas de 20 minutos en casa + activación metabólica sin
                necesidad de gimnasio.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-purple-500 transition-colors" data-id="element-259">
              <h4 className="text-2xl font-bold text-purple-400 mb-2 flex items-center" data-id="element-260">
                <span className="mr-3" data-id="element-261">📓</span> TOMO 5 – Abdomen Plano y
                Mantenimiento
              </h4>
              <p className="text-gray-300 text-lg" data-id="element-262">
                Protocolo antiinflamación + estrategia clara para evitar el
                efecto rebote.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-263">
            <p className="text-2xl font-bold text-white mb-8" data-id="element-264">
              Todo organizado paso a paso para que no tengas que pensar qué
              hacer cada día.
            </p>
          </div>
        </div>
      </div>
    </section>;
}